import styled from 'styled-components';

export const LoaderField = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`;
